import React, { ReactElement } from 'react'
import { IModalActions } from '../../interfaces/Modal'
import { attention } from '../../assets/images/images'

function ResetJourney({ onClose, onConfirm }: IModalActions): ReactElement {
  return (
    <div className="modalDialog modalLogout borderRadius0">
      <div className="textCenter">
        <div className="modalHeader">
          <span onClick={onClose} className="modalClose" />
        </div>
        <div className="modalIcon">
          <img src={attention} alt="attention" />
        </div>
      </div>
      <div className="modalContent pb3">
        <h1 className="mb35 mt4 lh29 modalTitle">
          Recommencer la mise à jour de mes informations
        </h1>
        <p className="fontWeightBold mb35 textLeft">
          Vous serez redirigé vers la première étape et devrez à nouveau
          renseigner vos informations. Etes-vous certain(e) de vouloir
          recommencer votre parcours ?
        </p>
        <div className="dFlex justifyContentBetween flexWrap">
          <button
            onClick={onClose}
            className="btn btnOutline wFull wAutoSm mb15 mb0sm mr1sm"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
          >
            Recommencer
          </button>
        </div>
      </div>
    </div>
  )
}

export default ResetJourney
